export interface GlobalState {
	loginAsUserId: string;
}

export const initialGlobalState: GlobalState = {
	loginAsUserId: null,
};
